import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import { prepareReviews } from '../../mappers/prepareReviews';
import {
  fetchGetReviews,
  IGetReviewsRequest,
  IGetReviewsResponse200,
  IGetReviewsResponse400,
} from '../../repositories/newbuilding-reviews/v1/get-reviews';

interface IFetchReviewsParams {
  httpApi: IHttpApi;
  parameters: IGetReviewsRequest;
}

export async function fetchReviews({ httpApi, parameters }: IFetchReviewsParams) {
  const result = await fetchGetReviews<IGetReviewsResponse200, IGetReviewsResponse400>({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#fetchReviews',
      message: result.response.message as string,
    });
  }

  return prepareReviews(result.response);
}
